export const partsEvaluationData = [
  { name: "roda", label: "Roda" },
  { name: "estribo", label: "Estribo" },
  { name: "kitPff", label: "Kit PPF" },
  { name: "trocaPlaca", label: "Troca de Placa" },
  { name: "blocoOptico", label: "Bloco Óptico" },
  { name: "chaveIgnição", label: "Chave Ignição" },
  { name: "maneteDeFreio", label: "Manete de Freio" },
  { name: "desempenoChassi", label: "Desempeno Chassi" },
  { name: "suporteCelular", label: "Suporte do Celular" },
  { name: "paralamaDianteiro", label: "Para-lama Dianteiro" },
  { name: "maneteDaEmbreagem", label: "Manete da Embreagem" },
  { name: "protetorCarenagem", label: "Protetor de Carenagem" },
  { name: "ponteira", label: "Ponteira do Escapamento" },
  { name: "carenagemRabetaCentral", label: "Carenagem Rabeta Central" },
  { name: "tampaLateralDireita", label: "Tampa Lateral Direita" },
  { name: "tampaLateralEsquerda", label: "Tampa Lateral Esquerda" },
  { name: "borrachaEstriboDireita", label: "Borracha do Estribo Direita" },
  { name: "espelhoRetrovisorDireito", label: "Espelho Retrovisor Direito" },
  { name: "abaLateralTanqueDireita", label: "Aba Lateral do Tanque Direita" },
  { name: "borrachaEstriboEsquerda", label: "Borracha do Estribo Esquerda" },
  { name: "espelhoRetrovisorEsquerdo", label: "Espelho Retrovisor Esquerdo" },
  { name: "abaLateralTanqueEsquerda", label: "Aba Lateral do Tanque Esquerda" },
  { name: "pinturaTanqueSemLanternagem", label: "Pintura Tanque (Sem Lanternagem)" },
  { name: "pinturaTanqueComLanternagem", label: "Pintura Tanque (Com Lanternagem)" },
  { name: "carenagemRabetaLateralDireita", label: "Carenagem da Rabeta Lateral Direita" },
  { name: "carenagemRabetaLateralEsquerda", label: "Carenagem da Rabeta Lateral Esquerda" },
];